import { render, staticRenderFns } from "./word-cloud-map.vue?vue&type=template&id=5184cdde&"
import script from "./word-cloud-map.vue?vue&type=script&lang=js&"
export * from "./word-cloud-map.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "word-cloud-map.vue"
export default component.exports